import React from 'react'
import PropTypes from 'prop-types'
// import { Link } from 'react-router-dom'


export default function Navbar(props) {
  return (
    <nav className ={`navbar navbar-expand-lg navbar-${props.Mode} bg-${props.Mode}`}>
  <div className ="container-fluid">
    <a className ="navbar-brand" href="/">{props.title}</a>
    <button className ="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className ="navbar-toggler-icon"></span>
    </button>
    <div className ="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className ="navbar-nav me-auto mb-2 mb-lg-0">
        <li className ="nav-item">
          <a className ="nav-link active" aria-current="page" href ="/"> Home  </a>
        </li>
        <li className ="nav-item">
          <a className ="nav-link" href ="/about" > {props.aboutText}  </a>
        </li>
      </ul>
      {/* <form className ="d-flex" role="search">
        <input className ="form-control me-2" type="search" placeholder="Search" aria-label="Search"/>
        <button className ="btn btn-outline-primary" type="submit">Search</button>
      </form> */}
      <div className={`form-check form-switch text-${props.Mode ==='light'?'dark':'light'}`}> 
      {/* In the above line ? is use for the ternaray oprator. */}
  <input className="form-check-input" onClick={props.toggleMode} type="checkbox" role="switch" id="flexSwitchCheckDefault"/>
  <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Enable DarkMode</label>
  {/* <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Enable lightMode</label> */}
      </div>
    </div>
    
  </div>
 </nav>
  )
}

Navbar.propTypes = {
    title:PropTypes.string.isRequired,
    aboutText:PropTypes.string
}

Navbar.defaultProps = {
    title: 'Set title here',
    aboutText: "About "
  };

  // export default function Navbar